import module from 'cliente/module.js'
import template from './template.html'

export class ClienteFacturasComponent {
  idCliente
  limite = 20
  data = null
  resultados = []
  filtro = ''

  constructor ($filter, $moment, ClienteFacturas) {
    this.filterBy = $filter('filter')
    this.$moment = $moment
    this.ClienteFacturas = ClienteFacturas
  }

  $onInit () {
    return this.ClienteFacturas.get(this.idCliente)
      .then(({data}) => (this.data = data))
      .then(() => (this.filtrar()))
      .finally(() => {
        let hoy = (new Date()).getFullYear()
        this.data.forEach((item) => {
          let formato = hoy === item.Fecha.getFullYear() ? 'MMMM D' : 'MMMM D, YYYY'

          item.Agrupacion = this.$moment(item.Fecha).format(formato).toUpperCase()
        })
      })
  }

  filtrar () {
    this.pendientes = this.filterBy(this.data, this.filtro)
    this.resultados = []
    this.siguiente()
  }

  siguiente () {
    this.resultados = this.resultados.concat(this.pendientes.splice(0, this.limite))
  }
}

module.component('clienteFacturas', {
  controller: ClienteFacturasComponent,
  template,
  bindings: {
    idCliente: '<',
  },
})



// WEBPACK FOOTER //
// ./src/cliente/components/facturas/component.js